module.exports = __webpack_public_path__ + "Roboto-Light.69f8a0617ac472f78e45.woff2";


//////////////////
// WEBPACK FOOTER
// ./~/angular-bootstrap-md/font/roboto/Roboto-Light.woff2
// module id = 462
// module chunks = 2